<template>
  <div class="cec-alerts-app">
    <div v-if="isVisible && alert" :class="wrapperClasses">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center py-4 py-md-3">
              <div class="alert-text mr-5 font-family-heebo-book font-size-18 font-size-lg-20">
                {{ alert.field_description }}
              </div>
              <div class="actions d-flex flex-shrink-0">
                <div class="cta flex-shrink-0">
                  <a
                    :href="alert.field_link.url"
                    class="btn font-size-18 stretched-link mr-5 text-uppercase px-5 py-2 border-2"
                    :class="buttonClasses"
                  >
                    {{ alert.field_link.title }}
                  </a>
                </div>
                <button
                  type="button"
                  class="alert-close btn py-2 border-2 font-size-24"
                  :class="closeClasses"
                  @click="close"
                >
                  &times;
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/client/index.js'

export default {
  name: 'CECAlertsApp',
  data() {
    return {
      alert: null,
      id: ''
    }
  },
  computed: {
    cookieName() {
      return this.id.replace(/-/g, '_')
    },
    isVisible() {
      return !!(this.alert && this.getCookie(this.cookieName) !== '1')
    },
    wrapperClasses() {
      let classes = []
      switch (this.alert.field_alert_style) {
        case 'red_smoke':
          classes.push('bg-secondary', 'text-white')
          break
        case 'smoke_red':
        default:
          classes.push('bg-smoke')
          break
      }

      return classes
    },
    buttonClasses() {
      let classes = []
      switch (this.alert.field_alert_style) {
        case 'red_smoke':
          classes.push('btn-smoke')
          break
        case 'smoke_red':
        default:
          classes.push('btn-secondary')
          break
      }

      return classes
    },
    closeClasses() {
      let classes = []
      switch (this.alert.field_alert_style) {
        case 'red_smoke':
          classes.push('btn-outline-smoke')
          break
        case 'smoke_red':
        default:
          classes.push('btn-outline-dark')
          break
      }

      return classes
    }
  },
  watch: {
    isVisible() {
      this.$nextTick(function() {
        window.dispatchEvent(new Event('cecAlertVisibilityChange'))
      })
    }
  },
  mounted() {
    client({
      url: '/jsonapi/node/alert',
      method: 'get',
      params: {
        'filter[status][value]': 1,
        sort: '-changed',
        'page[limit]': 1
      }
    })
      .then(response => {
        if (response.data.data.length > 0) {
          this.alert = response.data.data[0].attributes
          this.id = response.data.data[0].id
        }
      })
      .catch(error => console.error(error))
  },
  methods: {
    close() {
      // Dismiss the alert.
      this.alert = null
      // Set cookie to not show this alert again.
      const maxAge = 90 * 24 * 60 * 60
      document.cookie = encodeURIComponent(this.cookieName) + '=1; max-age=' + maxAge
    },
    getCookie(cname) {
      const name = cname + '='
      const decodedCookie = decodeURIComponent(document.cookie)
      const ca = decodedCookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c[0] === ' ') {
          c = c.slice(1)
        }
        if (c.startsWith(name)) {
          return c.slice(name.length, c.length)
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.cec-alerts-app {
  .alert-text {
    @include media-breakpoint-up('lg') {
      font-family: $font-avenir-medium;
    }
  }

  // Hide CTA button on mobile.
  .cta {
    @include media-breakpoint-down('md') {
      text-indent: -99999px;
    }
  }

  .alert-close {
    z-index: 2;
    position: relative;
    line-height: 1;
    width: 50px;
  }
}
</style>
